import { get, post, postJson, postBlob, postJsonBlob,imagePost,deleteApi} from '../axios2'

/***
 * 模块管理查询接口
 * @param p/
 */
export const getConfigInfo = p => get(`/bananain/member-center/configInfo`, p)

/***
 * 全局配置查询接口
 * @param p/
 */
export const getGlobalConfig = p => get(`/bananain/member-center/global-config`, p)

/***
 * 全局配置保存接口
 * @param p/
 */
export const postGlobalConfig = p => postJson(`/bananain/member-center/global-config`, p)



/***
 * 权益列表分页查询接口
 * @param p/
 */
export const getMemberBenefit = p => postJson(`/bananain/member-benefit/page`, p)

/***
 * 权益启用/禁用接口
 * @param p/
 */
export const getStatus = p => get(`/bananain/member-benefit/status`, p)


/***
 * 等级列表查询接口
 * @param p/
 */
export const getRuleInfo = p => get(`/bananain/member-level/ruleInfo`, p)

/***
 * 权益分类列表查询接口
 * @param p/
 */
export const getCategoryList = p => get(`/bananain/member-benefit/category/list`, p)

/***
 * 新增/编辑权益
 * @param p/
 */
export const postMemberBenefit = p => postJson(`/bananain/member-benefit`, p)

// 上传图片
export const uploadpic = (p,type) => imagePost(`/public/upload/file/`+type, p);


/***
 * 权益列表查询接口
 * @param p/
 */
export const getBenefitInfo = p => get(`/bananain/member-level/benefitInfo`, p)

/***
 * 等级权益配置保存接口
 * @param p/
 */
export const saveBenefit = p => postJson(`/bananain/member-level/saveBenefit`, p)

/***
 * 权益IP配置保存接口
 * @param p/
 */
export const saveBenefitIp = p => postJson(`/bananain/member-level/saveBenefitIp`, p)


/***
 * 生日权益配置查询接口
 * @param p/
 */
export const getBenefitConfig = p => get(`/bananain/member-birthday/benefit-config`, p)

/***
 * 生日权益配置查询接口
 * @param p/
 */
export const postBenefitConfig = p => postJson(`/bananain/member-birthday/benefit-config`, p)


/***
 * 日常/节日IP配置接口查询接口
 * @param p/
 */
export const getIpConfigInfo = p => get(`/bananain/member-level/ipConfigInfo`, p)


/***
 * 新建/编辑 日常/节日IP配置接口
 * @param p/
 */
export const saveIpConfig = p => postJson(`/bananain/member-level/saveIpConfig`, p)

/***
 * 删除 日常/节日IP配置接口
 * @param p/
 */
export const delIpConfig = p => deleteApi(`/bananain/member-level/delIpConfig/`+p)
